'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import H7 from 'UIComponents/elements/headings/H7';
import UILink from 'UIComponents/link/UILink';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import { getCategoryCanHaveGlobalDefaultValue, getCategoryTextForOption, i18nKey } from '../../utils/properties';
import Fallback from './internal/Fallback';
import UserProperties from './internal/UserProperties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderUserProperties = props => {
  const {
    currentOption,
    defaultValue,
    dropdownClassName,
    fallback,
    isUserProperty,
    onUserPropertySelect,
    owners,
    settingsLink,
    userProperty
  } = props;
  if (!isUserProperty) {
    return null;
  }
  const categoryCanHaveGlobalDefaultValue = getCategoryCanHaveGlobalDefaultValue(currentOption.category);
  return /*#__PURE__*/_jsx(UserProperties, {
    categoryCanHaveGlobalDefaultValue: categoryCanHaveGlobalDefaultValue,
    defaultValue: defaultValue,
    dropdownClassName: dropdownClassName,
    localDefaultValue: fallback,
    onUserPropertySelect: onUserPropertySelect,
    owners: owners,
    selectedUserProperty: userProperty,
    settingsLink: settingsLink
  });
};
const propTypes = {
  currentOption: PropTypes.object.isRequired,
  enableFallback: PropTypes.bool.isRequired,
  fallback: PropTypes.string,
  isGlobalFallback: PropTypes.bool,
  onBackClick: PropTypes.func.isRequired,
  onFallbackChange: PropTypes.func.isRequired,
  onIsGlobalFallbackChange: PropTypes.func.isRequired,
  propertyOptions: PropTypes.array.isRequired,
  settingsLink: PropTypes.string.isRequired,
  tooltipClassName: PropTypes.string,
  handleInsertToken: PropTypes.func.isRequired
};
const displayName = 'TokenEditor';
const TokenEditor = props => {
  const {
    currentOption,
    enableFallback,
    fallback,
    isGlobalFallback,
    onBackClick,
    onFallbackChange,
    onIsGlobalFallbackChange,
    propertyOptions,
    settingsLink,
    tooltipClassName,
    handleInsertToken
  } = props;
  const categoryText = getCategoryTextForOption(currentOption, propertyOptions);
  const readableCategory = `${categoryText.charAt(0).toUpperCase()}${categoryText.slice(1)}`;
  return /*#__PURE__*/_jsxs("div", {
    className: "m-x-5",
    children: [/*#__PURE__*/_jsx(UIBreadcrumbs, {
      className: "m-top-0",
      flush: true,
      children: /*#__PURE__*/_jsx(UILink, {
        "data-test-id": "personalize-back-link",
        onClick: onBackClick,
        onMouseDown: evt => evt.preventDefault(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('back')
        })
      })
    }), /*#__PURE__*/_jsx(H7, {
      className: "m-bottom-0",
      children: `${readableCategory}: ${currentOption.text}`
    }), renderUserProperties(props), enableFallback && /*#__PURE__*/_jsx(Fallback, {
      fallback: fallback,
      setFallback: onFallbackChange,
      isGlobalFallback: isGlobalFallback,
      setIsGlobalFallback: onIsGlobalFallbackChange,
      currentOption: currentOption,
      settingsLink: settingsLink,
      tooltipClassName: tooltipClassName,
      handleInsertToken: handleInsertToken
    })]
  });
};
TokenEditor.propTypes = propTypes;
TokenEditor.displayName = displayName;
export default TokenEditor;